module.exports = __webpack_public_path__ + "img/中南大学湘雅第三医院-300x296.903db95b.jpg";